// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvertisersPage_wrapper__YKwnn","header":"AdvertisersPage_header__lY+Nl","titleRow":"AdvertisersPage_titleRow__-EGUw","title":"AdvertisersPage_title__zIDRl"};